import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { ReviewOrderDto } from 'src/app/domain/models/dto/review-order.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';

@Component({
  selector: 'app-approve-order-confirm',
  templateUrl: './approve-order-confirm.component.html',
  styleUrls: ['./approve-order-confirm.component.scss'],
})
export class ApproveOrderConfirmComponent implements OnInit {
  boobleModalData: any;
  loading: boolean;
  private readonly notifier: NotifierService;

  constructor(
    private modalService: BoobleModalService,
    notifierService: NotifierService,
    private readonly ordersService: OrdersService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {}

  closeModal() {
    this.modalService.dismiss(null);
  }

  approveConfirm() {
    this.loading = true;
    this.boobleModalData.approved = true;

    const approvedData = new ReviewOrderDto();

    (approvedData.id = this.boobleModalData.id),
      (approvedData.approved = true),
      (approvedData.reprovedMsg = null);

    this.ordersService.orderReview(approvedData).subscribe({
      next: (orderResult) => {
        this.loading = false;
        this.closeModal();
        this.notifier.notify(
          'success',
          'Ordem aprovada com sucesso e em instantes estará disponível a cotação para o cliente.'
        );
        this.ordersService.updateOrderView();
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }
}
